module.exports = __webpack_public_path__ + "img/Urban_spcaes_Green-spaces.0b83798c.png";